<template>
    <v-layout justify-end="" style="min-height:100px;" class="pr-4">
        <v-flex :xs5="small" :sm2="!small" :xs6="!small">
            <v-slide-x-transition>
                <v-btn rounded="" block="" v-if="app.form.hasChange" @click="resetObject()" color="warning">Reset</v-btn>
            </v-slide-x-transition>
        </v-flex>
        <v-flex :xs5="small" :offset-xs1="small" :sm2="!small" :xs6="!small" class="pl-3">
            <v-slide-x-transition>
                <v-btn :disabled="app.form.disabled" rounded="" block="" v-if="app.form.hasChange" @click="updateObject()" color="success">Opslaan</v-btn>
            </v-slide-x-transition>
        </v-flex>     
    </v-layout>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    small: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions(["resetObject", "updateObject"])
  },
  computed: {
    ...mapState(["app"])
  }
};
</script>
